<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :disableExporting="disableExporting()"
        ></dx-grid>

        <v-dialog persistent v-model="importDialog" max-width="450">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Import Students</v-card-title
                >
                <v-layout row class="mb-2">
                    <a @click.stop="downloadSampleFile()" class=""
                        >Sample File</a
                    ></v-layout
                >
                <v-layout row>
                    <v-select
                        class="mb-0"
                        :items="schoolSources.map((s) => s.schoolName)"
                        label="School Source"
                        v-model="schoolSource"
                        ref="schoolSource"
                        :rules="[rules.required]"
                    ></v-select>
                    <v-btn
                        style="height: 28px;"
                        class="ml-2 mt-3"
                        small
                        color="success"
                        @click="openSchoolSourcesDialog"
                        >School Sources</v-btn
                    >
                </v-layout>
                <v-combobox
                    class="mb-2 mt-0"
                    hide-details
                    :items="sources"
                    label="Import Source"
                    v-model="importSource"
                ></v-combobox>

                <!-- <v-checkbox
                    v-model="updateSource"
                    label="Update Import Source"
                    color="success"
                    hide-details
                    class="mb-3"
                ></v-checkbox> -->
                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Import
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="pt-2 mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".xlsx, .xls"
                    @change="onFilePicked($event)"
                />
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeImportDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="importFile()"
                    >
                        import
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="exportDialog" max-width="450">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Export Registration Form</v-card-title
                >

                <v-radio-group class="mt-2" v-model="exportMode" row>
                    <v-radio
                        color="success"
                        label="One File"
                        value="onefile"
                    ></v-radio>
                    <v-radio
                        color="success"
                        label="In Separate Files"
                        value="separate"
                    ></v-radio>
                </v-radio-group>

                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="exportDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="exportRegistrationForm()"
                    >
                        export
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Student</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child First
                        </div>
                        <div>{{ clickedRow.firstH }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child Last
                        </div>
                        <div>{{ clickedRow.lastH }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.fatherFirstH }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{
                                clickedRow.address1 +
                                    " " +
                                    (clickedRow.apt ? clickedRow.apt : "")
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Class
                        </div>
                        <div>
                            {{ clickedRow.source + " " + clickedRow.class }}
                        </div>
                    </v-layout>

                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            DOB
                        </div>
                        <div>
                            {{ clickedRow.dob | date }}
                        </div>
                    </v-layout>
                    <!--                     <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div class="font-weight-medium caption pa-1 px-2 cyan" style="color: #fff; width: fit-content;">{{ clickedRow.anslID }}</div>
                    </v-layout> -->
                    <div
                        class="font-weight-medium caption pa-1 px-2 cyan mb-2"
                        style="color: #fff; width: fit-content;"
                        v-if="clickedRow.anslID"
                    >
                        ANSL ID: {{ clickedRow.anslID }}
                    </div>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <v-text-field
                        v-model="clickedRow.status"
                        label="Status"
                        hide-details
                        class="mb-4"
                    ></v-text-field>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <v-layout row justify-space-between>
                        <div>
                            <div class="font-weight-medium mb-0">
                                Match To ANSL Account
                            </div>
                            <v-btn
                                outline
                                class="text-xs-center"
                                color="success"
                                small
                                @click="searchAnslDialog = true"
                                >Search ANSL Accounts</v-btn
                            >
                        </div>
                        <div>
                            <div class="font-weight-medium mb-0">
                                Match To DOE
                            </div>
                            <v-btn
                                outline
                                class="text-xs-center"
                                color="success"
                                small
                                @click="searchDoeDialog = true"
                                >Search DOE Accounts</v-btn
                            >
                        </div>
                    </v-layout>

                    <div v-if="anslAccount.personID">
                        <div class="my-2 font-weight-medium text-success">
                            Selected ANSL Account
                        </div>
                        <div
                            style="border-radius: 4px"
                            class="pa-2 yg-student-account-match"
                        >
                            <div>
                                <div
                                    class="font-weight-medium caption pa-1 px-2 cyan"
                                    style="color: #fff; width: fit-content;"
                                >
                                    {{ anslAccount.personID }}
                                </div>
                                <div class="pt-2">
                                    {{
                                        anslAccount.name +
                                            " - " +
                                            anslAccount.nameH
                                    }}
                                </div>
                            </div>
                            <div>
                                <div class="pb-2">
                                    {{
                                        anslAccount.address1 +
                                            " " +
                                            anslAccount.city +
                                            " " +
                                            anslAccount.zip
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="doeData.reG_ID" class="mt-3">
                        <div class="my-2 font-weight-medium text-success">
                            Selected DOE
                        </div>
                        <div
                            style="border-radius: 4px"
                            class="pa-2 yg-student-account-match"
                        >
                            <div>
                                <div
                                    class="font-weight-medium caption pa-1 px-2 cyan"
                                    style="color: #fff; width: fit-content;"
                                >
                                    {{ doeData.reG_ID }}
                                </div>
                                <div class="pt-2">
                                    {{ doeData.first + " - " + doeData.last }}
                                </div>
                            </div>
                            <div>
                                <div class="pb-2">
                                    {{
                                        doeData.house +
                                            " " +
                                            doeData.street +
                                            " " +
                                            doeData.zip
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-2">
                        <v-layout row>
                            <div
                                class="font-weight-medium pt-2 mt-2 text-success mr-2"
                            >
                                Registration Form
                            </div>

                            <v-btn
                                color="success"
                                small
                                @click="openAddRegistrationForm"
                                >{{
                                    clickedRegForm && clickedRegForm.id
                                        ? "Update"
                                        : "Add"
                                }}</v-btn
                            >
                        </v-layout>
                        <div
                            style="border-radius: 4px"
                            class="pa-2 yg-student-account-match"
                            v-if="clickedRegForm.id"
                        >
                            <div>
                                <div
                                    class="font-weight-medium caption pa-1 px-2 cyan"
                                    style="color: #fff; width: fit-content;"
                                >
                                    {{ clickedRegForm.status }}
                                </div>
                                <div class="pt-2">
                                    Entered On:
                                    {{ clickedRegForm.enteredOn | time }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="save"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="statusUpdaterDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2">Update Status</v-card-title>
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{ student.firstH + " " + student.lastH }}
                            </div>
                            <div class="caption">
                                Father: {{ student.fatherFirstH }}
                            </div>
                            <div class="caption">
                                {{
                                    student.address1 +
                                        " " +
                                        (student.apt ? student.apt : "")
                                }}
                            </div>
                            <div class="body-2">
                                {{ student.source + " " + student.class }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>
                    <v-text-field
                        v-model="status"
                        label="Status"
                        outline
                        hide-details
                        class="mb-3 mt-2"
                    ></v-text-field>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="statusUpdaterDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveStatus"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="searchAnslDialog" max-width="1600">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="donors"
                    name="voting-student-match-to-ansl"
                    :columns="accountsColumns"
                    title="ANSL Accounts"
                    v-bind:hideActions="true"
                    navigationPath="onSearchAccountsRowClicked"
                    navigationField="onSearchAccountsRowClicked"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>

        <v-dialog v-model="searchDoeDialog" max-width="1600">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="doe?isCurrent=true"
                    name="voting-student-match-to-ansl"
                    :columns="doeColumns"
                    title="DOE"
                    v-bind:hideActions="true"
                    navigationPath="onSearchDoeRowClicked"
                    navigationField="onSearchDoeRowClicked"
                    :onRowClicked="onSearchDoeRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>

        <v-dialog v-model="schoolSourcesDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row class="">
                    <div class="headline mb-3">School Sources</div>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="my-0"
                        style="height: 28px;"
                        small
                        color="success"
                        @click="newSchoolSource"
                        v-if="!addingSchoolSource"
                        >New School Source</v-btn
                    >
                </v-layout>

                <div
                    v-if="addingSchoolSource"
                    style="border: 2px solid #4caf50;"
                    class="pa-2 mb-3"
                >
                    <v-text-field
                        v-model="newSchoolName"
                        :rules="[rules.required]"
                        ref="newSchoolName"
                        label="New School Source"
                    ></v-text-field>

                    <v-spacer></v-spacer>
                    <v-btn
                        class="mt-0 mr-1"
                        small
                        dark
                        color="default"
                        @click="addingSchoolSource = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        class="mt-0"
                        small
                        color="success"
                        :loading="processing"
                        @click="saveSchoolSource"
                        >Save</v-btn
                    >
                </div>

                <div v-for="(schoolSource, index) in schoolSources">
                    <v-layout row>
                        <div class="pt-2">{{ schoolSource.schoolName }}</div>

                        <v-btn
                            @click="openDeleteSchoolSourceDialog(schoolSource)"
                            flat
                            icon
                            class="my-0"
                            color="success"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-layout>
                    <v-divider
                        v-if="index + 1 < schoolSources.length"
                    ></v-divider>
                </div>

                <v-card-actions class="mr-0 pr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="schoolSourcesDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteSchoolSourceDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete School Source</v-card-title
                >

                <div>
                    School Source
                    <span class="font-weight-medium">{{
                        schoolSourceToDelete.schoolName
                    }}</span>
                    will be deleted
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteSchoolSourceDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteSchoolSource()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addRegFormDialog" max-width="400">
            <voting-reg-form
                ref="regFormDialog"
                :form="clickedRegForm"
                :student="clickedRow"
                :reload="loadRegForm"
                :close="closeAddRegistrationForm"
            ></voting-reg-form>
        </v-dialog>
    </div>
</template>

<script>
import JsZip from "jszip";
import votingRegForm from "./VotingRegForm.vue";

export default {
    components: {
        votingRegForm,
    },
    data: () => ({
        title: "Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",
        processing: false,
        uploading: false,
        importDialog: false,
        searchAnslDialog: false,
        searchDoeDialog: false,
        anslAccount: {},
        doeData: {},
        files: [],
        requestID: "",
        importSource: "",
        schoolSource: "",
        updateSource: false,
        sources: [],
        exportMode: "onefile",
        exportDialog: false,

        selected: [],
        statusUpdaterDialog: false,
        updateDialog: false,
        clickedRow: {},
        status: "",

        addRegFormDialog: false,
        clickedRegForm: {},
        schoolSources: [],
        schoolSourcesDialog: false,
        deleteSchoolSourceDialog: false,
        newSchoolName: "",
        schoolSourceToDelete: {},
        addingSchoolSource: false,

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                label: "ID",
                field: "id",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "last",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "first",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name Heb",
                field: "lastH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name Heb",
                field: "firstH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "School Source",
                field: "schoolName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Import Source",
                field: "source",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Apt",
                field: "apt",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "City",
                field: "city",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "County",
                field: "county",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "State",
                field: "state",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Zip",
                field: "zip",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "ANSL ID",
                field: "anslID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOE ID",
                field: "doeID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father ID",
                field: "fatherID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                format: "MM/dd/yyyy",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone",
                field: "phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Gander",
                field: "gander",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Reg Form",
                field: "hasRegForm",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Party",
                field: "party",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Council",
                field: "council",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Election",
                field: "election",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Assembly",
                field: "assembly",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Congress",
                field: "congress",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Senate",
                field: "senate",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Inactive",
                field: "IsInactive",
                visible: true,
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Last Updated",
                field: "lastUpdated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Created At",
                field: "createdAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Person ID",
                field: "personID",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Person ID..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: true,
                label: "City",
                field: "city",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Zip",
                field: "zip",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Father",
                field: "father",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Shver",
                field: "fatherInLaw",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],

        doeColumns: [
            {
                field: "first",
                label: "First",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "last",
                label: "Last",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "s",
                label: "Gander",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "personID",
                label: "Person ID",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "parentId",
                label: "Parent Id",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "house",
                label: "House",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "street",
                label: "Street",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "apt",
                label: "Apt",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "city",
                label: "City",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "zip",
                label: "Zip",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "isMatched",
                label: "Matched",
                type: "boolean",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "matchName",
                label: "Matched To",
                format: "",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                field: "dob",
                label: "DOB",
                format: "",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    async created() {
        this.loadSources();
        this.loadSchoolSources();
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Show Inactive",
                align: "left",
                type: "switch",
                action: this.onShowInactiveChanged,
            });

            this.actions.push({
                text: "Update Status",
                action: this.openUpdateStatusDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Import Students",
                action: this.openImportDialog,
            });
            // this.actions.push({
            //     text: "Export Registration Form",
            //     name: "ExportRegistrationForm",
            //     action: this.exportRegistrationForm,
            // });

            const exportFormAction = {
                text: "Export Registration Form",
                name: "ExportRegistrationForm",
                loading: false,
                showOnSelection: true,
            };

            exportFormAction.action = () =>
                this.openExportRegistrationForm(exportFormAction.loading);

            this.actions.push(exportFormAction);

            this.url = "YgStudents?includeInactive=false";
        },
        onShowInactiveChanged(value) {
            if (value) {
                this.url = "YgStudents?includeInactive=true";
            } else {
                this.url = "YgStudents?includeInactive=";
            }

            this.$refs.grid.reloadDataSource(this.url);
        },
        async loadSources() {
            this.sources = await this.$http.get("api/ygStudents/getSources");
        },
        async loadSchoolSources() {
            this.schoolSources = await this.$http.get(
                "api/ygStudents/getSchoolSources",
            );

            this.$forceUpdate();
        },
        openImportDialog() {
            this.importDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        closeImportDialog() {
            this.importDialog = false;
            this.files = [];
            this.$refs.files.value = "";
        },
        async importFile() {
            if (!this.$refs.schoolSource.validate(true)) return;

            if (!this.importSource) {
                return this.$notify({
                    group: "notification",
                    text: "Missing Source",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                var formData = new FormData();

                formData.append("upload_file", this.files[0]);

                const schoolSource = this.schoolSources.find(
                    (s) => s.schoolName == this.schoolSource,
                );

                const response = await this.$http.post(
                    "api/YgStudents/Import?user=" +
                        this.$store.state.authentication.user +
                        "&source=" +
                        this.importSource +
                        "&updateSource=" +
                        this.updateSource +
                        "&schoolID=" +
                        schoolSource.schoolID,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.$notify({
                    group: "notification",
                    text: "Students Saved",
                    type: "success",
                });

                this.processing = false;
                this.importDialog = false;
                this.files = [];
                this.$refs.files.value = "";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        downloadSampleFile() {
            window.location =
                "https://utaw.blob.core.windows.net/files/StudentsSample.xlsx";
        },
        openExportRegistrationForm() {
            this.exportDialog = true;
        },
        async exportRegistrationForm() {
            const action = this.actions.find(
                (a) => a.name == "ExportRegistrationForm",
            );

            //const students = this.$refs.grid.grid.getDataSource().items();
            //const students = await this.$refs.grid.loadAll();
            let students = this.$refs.grid.getSelectedRowsData();

            try {
                this.processing = true;

                if (this.exportMode == "separate") {
                    const zip = new JsZip();

                    let i = 0;
                    for (const student of students) {
                        await this.export([student], zip);
                    }

                    zip.generateAsync({ type: "blob" }).then(function(content) {
                        const url = window.URL.createObjectURL(
                            new Blob([content]),
                        );
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "VoterRegistration.zip");
                        document.body.appendChild(link);
                        link.click();
                    });
                } else {
                    await this.export(students);
                }

                this.processing = false;
                this.exportDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async export(students, zip = null) {
            const response = await this.$http({
                url: "api/ygStudents/downloadVoterRegistrationForm",
                method: "POST",
                data: students,
                responseType: "blob",
            });

            if (zip) {
                const student = students[0];

                const fileName =
                    (student.branch ? student.branch : "") +
                    "_" +
                    (student.class ? student.class : "") +
                    " " +
                    (student.first ? student.first : "") +
                    " " +
                    (student.last ? student.last : "") +
                    ".pdf";
                zip.file(fileName, new Blob([response]));

                return;
            }

            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "VoterRegistration.pdf");
            document.body.appendChild(link);
            link.click();
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        disableExporting() {
            const isAdmin = this.isAdmin();
            return !isAdmin;
        },
        openSchoolSourcesDialog() {
            this.schoolSourcesDialog = true;
        },
        openAddRegistrationForm() {
            this.addRegFormDialog = true;

            if (this.$refs.regFormDialog) {
                this.$refs.regFormDialog.votingRegForm.type = "Son";
                this.$refs.regFormDialog.resetValidation();
            }
        },
        closeAddRegistrationForm() {
            this.addRegFormDialog = false;
        },
        async loadRegForm() {
            const response = await this.$http.get(
                "api/votingRegstrationFormStatus/getByStudentID?studentID=" +
                    this.clickedRow.id,
            );

            this.clickedRegForm = response ? response : {};
        },
        openUpdateStatusDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.statusUpdaterDialog = true;
        },
        async onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            await this.loadRegForm();

            this.updateDialog = true;
        },
        onSearchAccountsRowClicked(row) {
            this.searchAnslDialog = false;

            this.anslAccount = row;
        },
        onSearchDoeRowClicked(row) {
            this.searchDoeDialog = false;

            this.doeData = row;
        },
        async save() {
            try {
                this.processing = true;

                const data = this.clickedRow;

                if (this.anslAccount && this.anslAccount.personID) {
                    data.anslID = this.anslAccount.personID;
                }

                if (this.doeData && this.doeData.reG_ID) {
                    data.user = this.$store.state.authentication.user;
                    data.doeID = this.doeData.reG_ID;
                }

                await this.$http.post("api/YgStudents/Save", [data]);

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveStatus() {
            if (!this.selected.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.status) {
                return this.$notify({
                    text: "Missing Status",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/YgStudents/Save",
                    this.selected.map((s) => {
                        s.status = this.status;

                        return s;
                    }),
                );

                this.processing = false;
                this.statusUpdaterDialog = false;
                this.status = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        newSchoolSource() {
            this.newSchoolName = "";
            this.addingSchoolSource = true;
        },
        async saveSchoolSource() {
            if (!this.$refs.newSchoolName.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/ygStudents/addSchoolSource", {
                    schoolName: this.newSchoolName,
                });

                this.$notify({
                    group: "notification",
                    text: "School Source Added",
                    type: "success",
                });

                this.addingSchoolSource = false;
                this.processing = false;
                this.loadSchoolSources();
            } catch (e) {
                this.processing = false;
            }
        },
        openDeleteSchoolSourceDialog(schoolSource) {
            this.schoolSourceToDelete = schoolSource;
            this.deleteSchoolSourceDialog = true;
        },
        async deleteSchoolSource() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/ygStudents/deleteSchoolSource?id=" +
                        this.schoolSourceToDelete.schoolID,
                );

                this.$notify({
                    group: "notification",
                    text: "School Source Deleted",
                    type: "success",
                });

                this.deleteSchoolSourceDialog = false;
                this.processing = false;
                this.loadSchoolSources();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.accounts-search.container {
    padding-top: 0px;
}
.yg-student-account-match {
    border: 2px solid #4caf50;
}
</style>
